// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import JsonExcel from 'vue-json-excel'
import Vuex from 'vuex'
import ServerError from './views/pages/500'
Vue.component('ServerError', ServerError)

import Viewer from 'v-viewer'
Vue.use(Viewer)
import 'viewerjs/dist/viewer.css'

// import superAdmin from './views/adminRegistration/superAdminRegistration'
// Vue.component('superAdmin', superAdmin)

import Admins from './views/adminRegistration/adminRegistration'
Vue.component('Admins', Admins)

import Notifications from 'vue-notification'
Vue.use(Notifications)

window.axios = require('axios')

Vue.prototype.baseURL = 'http://3.6.245.85' // URL for File retriving Globaly initialized
axios.defaults.baseURL = 'http://3.6.245.85' //Production Server URL
// Vue.prototype.baseURL = 'http://192.168.50.75:7000' // URL for File retriving Globaly initialized
// axios.defaults.baseURL = 'http://192.168.50.75:7000' //Production Server URL
// Vue.prototype.baseURL = 'http://192.168.43.152:7000' // URL for File retriving Globaly initialized
// axios.defaults.baseURL = 'http://192.168.43.152:7000' //Production Server URL
// axios.defaults.baseURL = 'http://localhost:3000' //Development Server URL
axios.defaults.timeout = 120000;

import VueSocketIO from 'vue-socket.io';

Vue.use(new VueSocketIO({
  debug: true,
  connection: 'http://3.6.245.85',
  vuex: {
      actionPrefix: 'SOCKET_',
      mutationPrefix: 'SOCKET_'
  },
}))

Vue.prototype.googleAPIKey = 'AIzaSyCaccNxbzwR9tMvkppT7bT7zNKjChc_yAw'
import BootstrapVueIcons from 'bootstrap-vue';
Vue.use(BootstrapVueIcons)

import SimpleVueValidation from 'simple-vue-validator';
Vue.use(SimpleVueValidation);
Vue.prototype.Validator = SimpleVueValidation.Validator;

import vDialogs from 'v-dialogs';
Vue.use(vDialogs, { language: 'en' });

import VueElementLoading from 'vue-element-loading'
Vue.component('VueElementLoading', VueElementLoading)

// todo
// cssVars()
Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.component('downloadExcel', JsonExcel)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})
